module.exports = __webpack_public_path__ + "img/770.4138dc14.jpg";